var map = {
	"./screen1.png": 68,
	"./screen2.png": 69,
	"./screen3.png": 70,
	"./screen4.png": 71,
	"./screen5.png": 72,
	"./screen6.png": 73,
	"./screen7.png": 74,
	"./screen8.png": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;